import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/SecurityCacheInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/securityproviders`;
	}
	listProvidersByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/batch/project`, {
			...t,
			projectId: e
		}));
	}
	listAllProvidersByProjectId(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/project`, { projectId: e }));
	}
};
//#endregion
export { n as SecurityCacheInternalResource };

//# sourceMappingURL=SecurityCacheInternalResource.js.map